import 'jquery-ui';
import 'jquery-ui/ui/widgets/resizable';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/mouse';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/disable-selection';

const vmDraggable = $.widget('wochit.vmDraggable', $.ui.draggable, {
  self: function () {
    return { self: this };
  },

  _create: function () {
    this._super();

    if (this.options.cancelDragOnEscape) {
      $(window).on(
        'keydown',
        $.proxy(function (e) {
          if (e.keyCode === $.ui.keyCode.ESCAPE) {
            this.cancelDrag();
          }
        }, this)
      );
    }
  },

  /**
   * Cancel dragging (while being dragged)
   * based on hack from EleotleCram http://forum.jquery.com/topic/how-to-cancel-drag-while-dragging
   */
  cancelDrag: function () {
    console.log('cancelDrag', this.started);
    const mouseMoveEvent = document.createEvent('MouseEvents');
    const mouseUpEvent = document.createEvent('MouseEvents');
    const offScreen = -50000;

    mouseMoveEvent.initMouseEvent(
      'mousemove', // event type : click, mousedown, mouseup, mouseover, etc.
      true, // canBubble
      false, // cancelable
      window, // event's AbstractView : should be window
      1, // detail : Event's mouse click count
      offScreen, // screenX
      offScreen, // screenY
      offScreen, // clientX
      offScreen, // clientY
      false, // ctrlKey
      false, // altKey
      false, // shiftKey
      false, // metaKey
      0, // button : 0 = click, 1 = middle button, 2 = right button
      null // relatedTarget : Only used with some event types (e.g. mouseover and mouseout).
      // In other cases, pass null.
    );

    mouseUpEvent.initMouseEvent(
      'mouseup', // event type : click, mousedown, mouseup, mouseover, etc.
      true, // canBubble
      false, // cancelable
      window, // event's AbstractView : should be window
      1, // detail : Event's mouse click count
      offScreen, // screenX
      offScreen, // screenY
      offScreen, // clientX
      offScreen, // clientY
      false, // ctrlKey
      false, // altKey
      false, // shiftKey
      false, // metaKey
      0, // button : 0 = left, 1 = middle button, 2 = right button
      null // relatedTarget : Only used with some event types (e.g. mouseover and mouseout).
      // In other cases, pass null.
    );

    // Move the mouse pointer off screen so it won't be hovering a droppable
    document.dispatchEvent(mouseMoveEvent);

    // We need to restore this later
    const original = {
      revertDuration: this.options.revertDuration,
      revert: this.options.revert,
    };
    // no revert animation
    this.options.revertDuration = 0;
    // their drag is being reverted
    this.options.revert = true;
    // and the drag is forcefully ended
    // this.element.trigger('mouseup');

    document.dispatchEvent(mouseUpEvent);

    // restore original values
    this.options.revertDuration = original.revertDuration;
    this.options.revert = original.revert;
  },
});

/**
 * NOTE: [A.Block@20141207] overriding native `droppable` to cause calling `dropAccept` to test droppable state
 * with `event, ui` parameters
 */
const vmDroppable = $.widget('wochit.vmDroppable', $.ui.droppable, {
  _create: function () {
    let proportions;
    const o = this.options;
    const accept = o.accept;

    this.isover = false;
    this.isout = true;

    this.dropAccept = o.dropAccept; // <-- wochit.vmDroppable custom

    this.accept = $.isFunction(accept)
      ? accept
      : function (d) {
          return d.is(accept);
        };

    this.proportions = function (/* valueToWrite */) {
      if (arguments.length) {
        // Store the droppable's proportions
        // eslint-disable-next-line prefer-rest-params
        proportions = arguments[0];
      } else {
        // Retrieve or derive the droppable's proportions
        return proportions
          ? proportions
          : (proportions = {
              width: this.element[0].offsetWidth,
              height: this.element[0].offsetHeight,
            });
      }
    };

    this._addToManager(o.scope);

    o.addClasses && this.element.addClass('ui-droppable');
  },

  _drop: function (event, custom) {
    const draggable = custom || $.ui.ddmanager.current;
    let childrenIntersection = false;

    // Bail if draggable and droppable are same element
    if (
      !draggable ||
      (draggable.currentItem || draggable.element)[0] === this.element[0]
    ) {
      return false;
    }

    this.element
      .find(':data(ui-droppable)')
      .not('.ui-draggable-dragging')
      .each(function () {
        const inst = $(this).droppable('instance');
        if (
          inst.options.greedy &&
          !inst.options.disabled &&
          inst.options.scope === draggable.options.scope &&
          inst.dropAccept.call(inst, event, inst.ui(draggable)) && // <-- wochit.vmDroppable custom
          $.ui.intersect(
            draggable,
            $.extend(inst, { offset: inst.element.offset() }),
            inst.options.tolerance,
            event
          )
        ) {
          childrenIntersection = true;
          return false;
        }
      });
    if (childrenIntersection) {
      return false;
    }

    if (this.dropAccept.call(this, event, this.ui(draggable))) {
      // <-- wochit.vmDroppable custom
      if (this.options.activeClass) {
        this.element.removeClass(this.options.activeClass);
      }
      if (this.options.hoverClass) {
        this.element.removeClass(this.options.hoverClass);
      }
      this._trigger('drop', event, this.ui(draggable));
      return this.element;
    }

    return false;
  },
});

/**
 * text-base timeline novo asset duration setter
 */
const novoDurationSetter = $.widget('wochit.novoDurationSetter', {
  options: {
    /** rounding precision */
    PRECISION: 2,
  },

  /**
   * Construct widget private event name from specific event name and current widget namespace
   * @param event {String}
   * @return {String}
   * @private
   */
  _event: function (event) {
    return event + this.eventNamespace;
  },

  _destroy: function () {},

  _handleEvent: function (e) {
    e.preventDefault();
    e.stopPropagation();
  },

  _create: function () {
    this.element.on('dragstart', 'a', function () {
      return false;
    });

    this.$lock = this.element.find('.-js-lock');
    this.$duration = this.element.find('.-js-duration');

    this.$lock.on(this._event('click'), 'a', this._unlock.bind(this));
    this.$duration
      .on(this._event('dblclick'), this._handleEvent.bind(this))
      .on(this._event('blur'), this._done.bind(this))
      .on(
        this._event('keydown'),
        function (e) {
          if ($.ui.keyCode.ENTER === e.which) {
            this._done();
          }
        }.bind(this)
      );

    this.state = {
      locked: true,
    };
    this._lock();
  },

  _unlock: function (e) {
    this._handleEvent(e);

    this.$lock.hide();
    this.$duration.val(
      this.options.getAsset().dialDuration.toFixed(this.options.PRECISION)
    );
    this.$duration.show().focus();

    this.state.locked = false;
  },

  _lock: function () {
    this.$lock.show();
    this.$duration.hide();

    this.state.lock = true;
  },

  _done: function () {
    this._changed();
    this._lock();
  },

  _changed: function () {
    const value = this.$duration.val();
    let duration = parseFloat(value);

    if (!isNaN(duration)) {
      duration =
        Math.round(duration * Math.pow(10, this.options.PRECISION)) /
        Math.pow(10, this.options.PRECISION);
      if (this.options.getAsset().dialDuration !== duration) {
        this._trigger('update', null, duration);
      }
    } else {
      this.$duration.val(
        this.options.getAsset().dialDuration.toFixed(this.options.PRECISION)
      );
    }
  },
});

const jQueryFix = {
  // https://stackoverflow.com/questions/32167437/jquery-ui-resizable-top-right-bug-when-using-containment
  resizableInContainment($resizableEl) {
    const resizePlugin = $resizableEl.resizable('instance').plugins.resize;
    const containmentPair = resizePlugin.find((pair) => {
      return pair.includes('containment');
    });

    containmentPair[1 /* function index */] = function (event) {
      const that = $(this).resizable('instance');
      const o = that.options;
      const cp = that.position;
      const co = that.containerOffset;
      const pRatio = that._aspectRatio || event.shiftKey;
      let cop = {
        top: 0,
        left: 0,
      };
      const ce = that.containerElement;
      let continueResize = true;

      if (ce[0] !== document && /static/.test(ce.css('position'))) {
        cop = co;
      }

      if (cp.left < (that._helper ? co.left : 0)) {
        that.size.width =
          that.size.width +
          (that._helper
            ? that.position.left - co.left
            : that.position.left - cop.left);

        if (pRatio) {
          that.size.height = that.size.width / that.aspectRatio;
          continueResize = false;
        }
        that.position.left = o.helper ? co.left : 0;
      }

      if (cp.top < (that._helper ? co.top : 0)) {
        that.size.height =
          that.size.height +
          (that._helper ? that.position.top - co.top : that.position.top);

        if (pRatio) {
          that.size.width = that.size.height * that.aspectRatio;
          continueResize = false;
        }
        that.position.top = that._helper ? co.top : 0;
      }

      const isParent =
        that.containerElement.get(0) === that.element.parent().get(0);
      const isOffsetRelative = /relative|absolute/.test(
        that.containerElement.css('position')
      );

      if (isParent && isOffsetRelative) {
        that.offset.left = that.parentData.left + that.position.left;
        that.offset.top = that.parentData.top + that.position.top;
      } else {
        that.offset.left = that.element.offset().left;
        that.offset.top = that.element.offset().top;
      }

      const woset = Math.abs(
        that.sizeDiff.width +
          (that._helper
            ? that.offset.left - cop.left
            : that.offset.left - co.left)
      );
      const hoset = Math.abs(
        that.sizeDiff.height +
          (that._helper ? that.offset.top - cop.top : that.offset.top - co.top)
      );

      if (
        (/w/.test(that.axis) ? that.position.left - 10 : woset) +
          that.size.width >=
        that.parentData.width
      ) {
        that.size.width = that.parentData.width - woset;
        if (pRatio) {
          that.size.height = that.size.width / that.aspectRatio;
          continueResize = false;
        }
      }

      if (
        (/n/.test(that.axis) ? that.position.top - 10 : hoset) +
          that.size.height >=
        that.parentData.height
      ) {
        that.size.height = that.parentData.height - hoset;
        if (pRatio) {
          that.size.width = that.size.height * that.aspectRatio;
          continueResize = false;
        }
      }

      if (!continueResize) {
        that.position.left = that.prevPosition.left;
        that.position.top = that.prevPosition.top;
        that.size.width = that.prevSize.width;
        that.size.height = that.prevSize.height;
      }
    };
  },
};

export { vmDraggable, vmDroppable, novoDurationSetter, jQueryFix };
